import { useQuery } from '@tanstack/react-query';

import { ExampleItem } from 'src/shared/types/exampleItem';

import getProductSamplingExampleItems from '../api/getProductSamplingExampleItems';

const getCreator = (item: ExampleItem) => {
  if (item.producer_user?.username) return item.producer_user?.username;

  if (item.producer_supplier_cloak) return item.producer_supplier_cloak;

  return 'Cavela';
};

const useProductSamplingExampleItems = (id: string) => {
  const query = useQuery({
    queryKey: ['product-sampling-example-items', id],
    queryFn: async () => {
      const response = await getProductSamplingExampleItems(id);

      return response.data
        ?.map?.((item) => ({
          ...item,
          creator: getCreator(item)
        }))
        ?.sort((a: ExampleItem, b: ExampleItem) => {
          const aDate = Date.parse(a.requested_at);
          const bDate = Date.parse(b.requested_at);

          if (aDate === bDate) return 0;

          return aDate > bDate ? -1 : 1;
        });
    },
    enabled: !!id,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    staleTime: 0
  });

  return query;
};

export default useProductSamplingExampleItems;
